import { render, staticRenderFns } from "./report.vue?vue&type=template&id=496c93c0&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"
import style0 from "./report.vue?vue&type=style&index=0&id=496c93c0&prod&scoped=true&lang=css"
import style1 from "./report.vue?vue&type=style&index=1&id=496c93c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c93c0",
  null
  
)

export default component.exports